import React, { useState, useEffect, useRef } from "react"
import {
  Box,
  Flex,
  Text,
  Container,
  Heading,
  Image,
  Grid,
} from "@theme-ui/components"
import ButtonArrowDefault from "../images/button-arrow-default.svg"
import ButtonArrowHover from "../images/button-arrow-hover.svg"
import { getPagePath } from "../utils/path"
import { InboundLink } from "./link"
import { LanguageSwitcherContext } from "../context/languageSwitcherContext"
import { stagger, useAnimate, motion } from "framer-motion"
import { useColorMode } from "theme-ui"
import { useInView } from "react-intersection-observer"

const HomeSolutionCollection = ({ block }) => {
  const locale = React.useContext(LanguageSwitcherContext).activeLocale
  const [isExpanded, setIsExpanded] = useState(false)
  const containerRef = useRef(null)
  const toggleCards = () => {
    setIsExpanded(!isExpanded)
  }
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsExpanded(true)
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.4,
        delay: 10,
      }
    )

    if (containerRef.current) {
      observer.observe(containerRef.current)
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current)
      }
    }
  }, [])
  return (
    <Container
      ref={containerRef}
      sx={{ mt: [3, 3, 4, 4], height: ["1600px", "1500px"] }}
    >
      <Box sx={{ mb: [3, 3, 3, 7] }}>
        <Text sx={{ display: "block" }} variant="kicker">
          {block.kicker}
        </Text>
        <Flex
          sx={{
            flexDirection: ["column", "column", "row", "row"],
            justifyContent: "space-between",
            my: [2, 2, 2, 4],
          }}
        >
          <Heading variant="h3" sx={{ flexBasis: "30%" }}>
            {block.title}
          </Heading>
          <Box
            sx={{ color: "dark", flexBasis: "30%", fontSize: "21px" }}
            dangerouslySetInnerHTML={{ __html: block.subtitle }}
          />
        </Flex>
      </Box>

      <Flex sx={{ flexDirection: "column", position: "relative" }}>
        {block.cards.map((card, index) => (
          <motion.div
            key={card.id}
            animate={{
              y: isExpanded ? index * 200 : 0,
            }}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            transition={{ ease: "easeInOut", duration: 0.5 }}
            style={{
              position: "absolute",
              width: "100%",
            }}
          >
            <Card key={index} index={index} card={card} locale={locale} />
          </motion.div>
        ))}
      </Flex>
    </Container>
  )
}

const Card = ({ card, locale, index }) => {
  const cardHeight = 150
  const cardSpacing = 200
  const cardVariants = {
    initial: {
      y: 0,
      opacity: 0,
    },
    animate: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 5,
        delay: index * 0.2,
      },
    },
  }

  const [isHovered, setIsHovered] = useState(false)
  const background = card.background.hex
  console.log(background)
  const colorMode = useColorMode()
  console.log(colorMode)
  return (
    <Box
      sx={{
        height: ["350px"],
        width: "100%",
        position: "absolute",
        top: index * cardSpacing,

        a: {
          textDecoration: "none",
        },
      }}
    >
      <InboundLink
        to={getPagePath(card.page.link, locale)}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Box
          sx={{
            height: "100%",
            borderRadius: "80px",
            backgroundColor:
              background === "#000000"
                ? "dark"
                : background === "#eeeeee"
                ? "#eeeeee"
                : "primary",
            color:
              background === "#000000"
                ? "light"
                : background === "#eeeeee"
                ? "#131E26"
                : "dark",
          }}
        >
          <Flex
            sx={{
              width: "100%",
              height: "100%",
              gap: [3, 3, 4, 7],
              p: [4, 5, 5, 6],
              justifyContent: "space-between",

              flexDirection: ["column", "column", "row", "row"],
            }}
          >
            <Flex
              sx={{
                flexDirection: "column",
                gap: [0, 0, 2],
                fontSize: [2, 2, 2, "18px"],
              }}
            >
              <Box
                sx={{
                  textTransform: "uppercase",
                  fontFamily: "mono",
                }}
              >
                {card.title}
              </Box>
              <Box
                sx={{
                  fontWeight: 500,
                  fontSize: [2, 2, "18px"],
                  textTransform: "uppercase",
                  fontFamily: "mono",
                }}
              >
                {card.subtitle}
              </Box>
              <Box
                sx={{
                  fontSize: "18px",
                  p: {
                    fontSize: [2, 1, 2, "20px"],
                    my: 0,
                    mt: "30px",
                  },
                }}
                dangerouslySetInnerHTML={{ __html: card.body }}
              />

              <Box sx={{ mt: "30px" }}>
                <Image src={ButtonArrowDefault} />
              </Box>
            </Flex>
            <Box sx={{ display: ["none", "none", "block", "block"] }}>
              <Image
                sx={{ width: "100%" }}
                src={
                  colorMode[0] === "dark" && card.blackImage
                    ? card.blackImage.url
                    : card.image.url
                }
              />
            </Box>
          </Flex>
        </Box>
      </InboundLink>
    </Box>
  )
}

export default HomeSolutionCollection
